let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4B6s3")).then(() => parcelRequire('4Q4Sb'));